import * as React from "react";
import {ButtonGroupItemProps} from "shared/controls/ButtonGroup/ButtonGroupItem";
import {ChangeEvent} from "react";


export class ButtonGroup extends React.Component<ButtonGroupProps, ButtonGroupState> {
    static defaultProps: Partial<ButtonGroupProps> = {
        AllowMultiple:false
    };
    public ButtonProps:ButtonGroupItemProps[];

    constructor(props: ButtonGroupProps) {
        super(props);
        let Items=React.Children.toArray(this.props.children) as any;
        this.ButtonProps=[];
        for(let item of Items)
            this.ButtonProps.push(item.props);
        this.state = {};
    }

    public render() {
        return (
            <div className={'rnbtn-group rnbtn-group-toggle'} style={{border:'1px solid #dfdfdf'}}>
                {this.ButtonProps.map(x=>
                    <label className={'rnbtn rnbtn-light '+(this.IsSelected(x.Value)?'active':'')} key={x.Value}>
                        <input checked={this.IsSelected(x.Value)} type={this.props.AllowMultiple?'checkbox':'radio'} name="options" id="option1" autoComplete="off" onChange={e=>this.ToggleValue(e,x)} />
                        {x.children}
                    </label>

                )}
            </div>
        )
    }

    public IsSelected(value:any)
    {
        if(this.props.AllowMultiple)
            return this.props.value.indexOf(value)>=0;
        else
            return this.props.value==value;
    }


    private ToggleValue(e: React.ChangeEvent<HTMLInputElement>,item:ButtonGroupItemProps) {

        if(this.props.AllowMultiple)
        {
            let values:any[]=this.props.value.splice(0);
            if(e.target.checked)
            {
                if(!values.find(x=>x==item.Value))
                    values.push(item.Value);

            }else
            {
                if(values.find(x=>x==item.Value))
                    values.splice(values.indexOf(item.Value),1);
            }
            this.props.onChange(values);

        }else{
            this.props.onChange(item.Value);
        }

        //this.props.onChange&&this.props.onChange(x.Value)
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ButtonGroupProps {
    value:any;
    onChange:(e:any)=>void;
    AllowMultiple?:boolean;

}

interface ButtonGroupState {

}

//#endregion "My Region"